import { JsonLdResult } from 'vet-bones/utils';

import { LanguageId } from 'src/common/constants/LanguageId';

export interface CollapseStateMap {
  [databaseName: string]: boolean;
}

export interface StoredQueryTags {
  /** Tags as retrieved from the platform. May contain synthetic tags (e.g.
   * voicebox, trigger) that should be filtered before display or save. **/
  userTags: Set<string>;
  voiceboxQuestions?: string[];
  triggerLimit?: number;
  triggerSchedule?: number;
  triggerTimeout?: number;
}

export interface StoredQuery {
  name: string;
  // Query path added in Stardog 12.0.0
  path?: string;
  creator: string;
  database: string;
  schema?: string;
  query: string;
  shared: boolean;
  // Was added in version 6.2.2
  reasoning?: boolean;
  // GraphQL stored queries were added in 6.2.3
  languageId?: LanguageId;
  // Voicebox tags added in 10.0.0
  tags: StoredQueryTags;
  additionalData?: Record<string, JsonLdResult[keyof JsonLdResult]>;
}

export interface StoredQueryMap {
  [databaseName: string]: StoredQuery[];
}

export class StoredQueryState {
  public isCached = false;

  public queries: StoredQuery[] = [];

  // public collapseState: CollapseStateMap = {};
}
